import { render, staticRenderFns } from "./PortfolioView.vue?vue&type=template&id=b3ade062&scoped=true&"
import script from "./PortfolioView.vue?vue&type=script&lang=js&"
export * from "./PortfolioView.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioView.vue?vue&type=style&index=0&id=b3ade062&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3ade062",
  null
  
)

export default component.exports